import { useEffect, useRef, useState } from 'react';
import Button from '../shared/button/Button';
import './Login.css';
import logo from './logo.png';
import { MessageDialog } from '../messagebox/MessageBox';
import { API } from '../../services/api/API';
import BasicCryp from '../../services/cryp/BasicCryp';
import ILocalCache from './interfaces/ILocalCache';
import { CurrentUser } from './CurrentUser';
import SocketClient from '../../services/socket/SocketClient';
import { LoaderDialog } from '../loader/Loader';
import Delay from '../../utils/Delay';
import Navigator from '../../utils/Navigator';
import DataFactory from '../../services/type1/DataFactory';


interface ILoginCache {
    Username: string, 
    Password : string,
    License: string,
    Time: Date
}

export default function Login() {

    let cachedKey = "logincached";

    let params = Navigator.GetQueryStringParams();

    let refLicInput = useRef<HTMLInputElement>(null);
    let refUserInput = useRef<HTMLInputElement>(null);
    let refPasswordInput = useRef<HTMLInputElement>(null);
    let refRememberInput = useRef<HTMLInputElement>(null);

    let [visible, setVisibility] = useState(false);
    

    CurrentUser.CheckLogin = () => {

        CurrentUser.CheckLocalCache();

        if (!CurrentUser.Token || !CurrentUser.User) {
            if (window.location.pathname != '/')
                window.location.pathname = '/';
            setVisibility(true);
        }
    }

    useEffect(() => {

        CurrentUser!.CheckLogin!();

        if (refLicInput.current && params.Any(s => s.Key == 'lic'))
            refLicInput.current.value = params.First(s => s.Key == 'lic').Value;
        if (refUserInput.current && params.Any(s => s.Key == 'user'))
            refUserInput.current.value = params.First(s => s.Key == 'user').Value;

        
        let loginCache : ILoginCache | undefined;
        let jsonLoginCached = localStorage.getItem(cachedKey);
        if(jsonLoginCached)
        {
            try{

                loginCache = JSON.parse(BasicCryp.Decode(jsonLoginCached));               

                if (refLicInput.current && loginCache?.License)
                    refLicInput.current.value = loginCache.License;
                 if (refPasswordInput.current && loginCache?.Password)
                    refPasswordInput.current.value = loginCache.Password;
                 if (refUserInput.current && loginCache?.Username)
                    refUserInput.current.value = loginCache.Username;
                 if (refRememberInput.current && loginCache?.Username)
                    refRememberInput.current.checked = true;

            }catch{}
        }

    }, []);


    let tryLogin = async () => {
        let user = (document.getElementById('login-user') as any).value;
        let password = (document.getElementById('senha-user') as any).value;
        let license = (document.getElementById('license-user') as any).value;




        if (!user) {
            MessageDialog.Toast("Atenção", "Informe o usuário.");
            return;
        }

        if (!password) {
            MessageDialog.Toast("Atenção", "Informe a senha do usuário.");
            return;
        }

        if (!license) {
            MessageDialog.Toast("Atenção", "Informe o número da licença.");
            return;
        }

        LoaderDialog.Show({
            Message: "Aguarde...",
            Title: "Login"
        });


        let loginResponse = await API.RequestAsync(`/auth/login?u=${user}&q=${password}&licenseNumber=${license}`, '', 'GET');


        await Delay.FromMS(2000);



        if (!loginResponse.ok) {
            LoaderDialog.Close();

            if (loginResponse.status == 404)
                MessageDialog.Toast("Erro ao autenticar", "Usuário e/ou senha invalidos.");
            else
                MessageDialog.Toast("Erro ao autenticar", await loginResponse.text());

            return;
        }

        let token = await loginResponse.json();              
       
        
        CurrentUser.Token =
        {
            Token: token.Token,
            ExpiresAt: token.ExpiresAt

        }

        CurrentUser.User = {
            Name: token.User.Name,
            Licence: token.User.License,
            LastLogin: token.User.LastLogin
        }

        let cache: ILocalCache =
        {
            Token: CurrentUser.Token,
            User: CurrentUser.User
        }


        try{

            if(refRememberInput.current && refRememberInput.current.checked)
            {
                let saveCached : ILoginCache = {

                    License : refLicInput?.current?.value ?? "",
                    Password : refPasswordInput?.current?.value ?? "",
                    Username : refUserInput?.current?.value ?? "",
                    Time : new Date()
                }

                localStorage.setItem(cachedKey, BasicCryp.Encode(JSON.stringify(saveCached)));
                
            }else
            {
                localStorage.removeItem(cachedKey);
            }

        }catch{

        }

        let encoded = BasicCryp.Encode(JSON.stringify(cache))

        window.sessionStorage.setItem('cache', encoded);
        window.sessionStorage.setItem('hash', BasicCryp.Encode(`_padstart${encoded.length}padend_`));


        SocketClient.Start();

        if (CurrentUser.UpdateFooter)
            CurrentUser.UpdateFooter(CurrentUser.User!);

        for (let func of CurrentUser.OnLogin) {
            func(CurrentUser.User);
        }

        Navigator.NavigateToHome();

    }

    return (
        <div className="LoginContainer" style={visible ? { display: 'flex' } : { display: 'none' }}>
            <div className="LoginComponent">
                <img src={logo} style={{ borderRadius: '7px' }} />
                <>
                    <code>Login</code>
                    <input ref={refUserInput} id="login-user" type='text' placeholder='Login do usuário'
                        onKeyUp={(e) => {
                            if (e.key == 'Enter')
                                document.getElementById('senha-user')?.focus();
                        }} />
                </>
                <>
                    <code>Senha</code>
                    <input ref={refPasswordInput} id="senha-user" type='password' placeholder='Senha do usuário'
                        onKeyUp={(e) => {
                            if (e.key == 'Enter')
                                document.getElementById('license-user')?.focus();
                        }} />
                </>
                <>
                    <code>Licença</code>
                    <input ref={refLicInput} id="license-user" type='text' placeholder='Licença do usuário'
                        onKeyUp={(e) => {
                            if (e.key == 'Enter')
                                tryLogin();
                        }}
                    />
                </>
                <>
                    <div className='check-remember'>
                        <input ref={refRememberInput} id="license-remember" type='checkbox' /> <code>Lembrar?</code>
                    </div>
                </>
               <br/>
                <>
                    <Button Text='Entrar' OnClickEventHandler={() => { tryLogin() }} Type='Save' />
                </>
                     
            </div>
        </div>
    )
}